import { LinkAnalyticsMicroMessageContent } from 'models/analytics';

function getLinkAnalyticsMicroMessage(link: LinkAnalyticsMicroMessageContent) {
  return {
    schemaName: 'affiliateHubLink',
    messageContent: link,
  };
}

export { getLinkAnalyticsMicroMessage };
